document.addEventListener('DOMContentLoaded',(e)=>{
let items = [];
let totalQuantity = 0; 

const addtoboxbtns = document.querySelectorAll('.add_to_box');
const cart = document.querySelector('.bundle_cart_drawer');
const cartOverlay = document.querySelector('.bundle_cart_drawer_overlay');
const closeDrawer = document.querySelector('.close_drawer');
const viewbox = document.querySelector('.view-box');
const cartItemsContainer = document.querySelector('.bundle_cart_drawer_items');
const bundle_progess_bar = document.querySelector('.bundle_progess_bar');
const progressCount = document.querySelector('#progress-bar-item-count');
const addToCartBtn = document.querySelector('.bundle_cart_drawer_footer button');
const drawerInfo = document.querySelector('.bundle_cart_drawer_info span');
 
const bundleLimit = parseInt(document.querySelector('.bundle_main').getAttribute('data-bundle-limit'));

// Cache of parsed variant maps, keyed by product id, so we only JSON.parse once per product.
const variantMapCache = {};

function getVariantMap(productId) {
  if (variantMapCache[productId]) return variantMapCache[productId];

  const el = document.querySelector(`.bundle_variant_map[data-product-id="${productId}"]`);
  if (!el) return [];

  try {
    const parsed = JSON.parse(el.textContent);
    variantMapCache[productId] = parsed;
    return parsed;
  } catch (err) {
    console.error('Could not parse variant map for product', productId, err);
    return [];
  }
}

// Given a productId and an array of {name, value} options (in product option order),
// find the matching variant entry from that product's variant map.
function resolveVariant(productId, options) {
  const variants = getVariantMap(productId);
  if (!variants.length) return null;

  // No options (simple product) -> single "Default Title" variant.
  if (!options || !options.length) return variants[0];

  const selectedValues = options.map(opt => opt.value);

  return variants.find(variant => {
    if (!Array.isArray(variant.options)) return false;
    return variant.options.length === selectedValues.length &&
      variant.options.every((val, i) => val === selectedValues[i]);
  }) || null;
}

window.selectMedia = function(input) {
  let selectWrapper = input.closest('.bundle_product');
  let button = selectWrapper.querySelector('button[onclick="addToBox(this)"]');
  let defaultMedia = selectWrapper.getAttribute('data-product-img');
  let image = selectWrapper.querySelector('.bundle_product_image img');

  let checkedSelects = selectWrapper.querySelectorAll('select[onchange="selectMedia(this)"]');

  let selectedText = Array.from(checkedSelects).map(el => {
    let option = el.options[el.selectedIndex];
    return option ? option.textContent.trim() : "";
  }).join(' / ');
  console.log(selectedText)
  let mediaSelect = selectWrapper.querySelector('select[name="media-select"]');
  let media = null;

  if (mediaSelect) {
    Array.from(mediaSelect.options).forEach(option => {
      if (option.textContent.trim() === selectedText) {
        media = option.getAttribute('data-media');
      }
    });
  }
  console.log(media);
  if (!media || media.includes('Liquid error')) {
    button.setAttribute('data-product-img', defaultMedia);
    image.setAttribute('src', defaultMedia);
    image.setAttribute('srcset', defaultMedia);
  } else {
    button.setAttribute('data-product-img', media);
    image.setAttribute('src', media);
    image.setAttribute('srcset', media);
  }
};


window.setMedia = function(input) {
  let inputWrapper = input.closest('.bundle_product_popup_inner_content');
  let button = inputWrapper.querySelector('button.popup_addbtn');
  let defaultMedia = inputWrapper.getAttribute('data-product-img');
  let checkedInputs = inputWrapper.querySelectorAll("input:checked");
  let selectedText = Array.from(checkedInputs).map(el => {
    let label = el.closest('label');
    return label ? label.textContent.trim() : el.value.trim();
  }).join(' / ');

  let select = inputWrapper.querySelector('select[name="media-select"]');
  let mediaId = null;
  let media = null;
  if (select) {
    Array.from(select.options).forEach(option => {
      if (option.textContent.trim() === selectedText) {
        mediaId = option.getAttribute('data-media-id');
        media = option.getAttribute('data-media');
        const sku = option.getAttribute('data-sku');
        const variantId = option.value;
        if (sku) button.setAttribute('data-product-sku', sku);
        if (variantId) button.setAttribute('data-product-variant-id', variantId);
      }
    });
  }
  console.log(media);
  if (media && media.includes('Liquid error')) {
   button.setAttribute('data-product-img',defaultMedia);
  } else if (media) {
   button.setAttribute('data-product-img',media);
  }

  let popupInner = input.closest('.bundle_product_popup_inner');
  if (popupInner && mediaId) {
    let slides = popupInner.querySelectorAll('.popup_image');
    slides.forEach((slide, index) => {
      if (slide.getAttribute('data-media-id') === mediaId) {
        $(popupInner).find('.popup_images').slick('slickGoTo', index);
      }
    });
  }

  return { selectedText, mediaId };
}


window.addToBox = function(button) {
  const isPopup = button.classList.contains('popup_addbtn');

  const productId = button.getAttribute('data-product-id');
  const productImage = button.getAttribute('data-product-img');
  const productTitle = button.getAttribute('data-product-title');

  let options = [];

  if (isPopup) {
    const wrapper = button.closest('.bundle_product_popup_content');
    if (!wrapper) return;

    const inputs = wrapper.querySelectorAll('input:checked');
    options = Array.from(inputs).map(input => ({
      name: input.getAttribute('data-option'),
      value: input.value
    }));
  } else {
    const wrapper = button.closest('.bundle_product');
    if (!wrapper) return;

    const selects = wrapper.querySelectorAll('select[data-select]');
    options = Array.from(selects).map(select => ({
      name: select.getAttribute('data-option'),
      value: select.value
    }));
  }

  // TEMP DEBUG — remove once the variant mismatch bug is confirmed fixed.
  console.log('[bundle debug] productId:', productId, 'options read from DOM:', JSON.parse(JSON.stringify(options)));

  // Resolve the real variant (id + sku) for whatever options are currently selected.
  // Falls back to the button's data attributes (default/first-available variant) if
  // the map lookup fails for any reason, so we never silently add nothing.
  const resolvedVariant = resolveVariant(productId, options);
  const variantId = resolvedVariant ? resolvedVariant.id : button.getAttribute('data-product-variant-id');
  const productSku = resolvedVariant ? resolvedVariant.sku : (button.getAttribute('data-product-sku') || '');

  // TEMP DEBUG — remove once the variant mismatch bug is confirmed fixed.
  console.log('[bundle debug] resolvedVariant:', resolvedVariant, '-> variantId:', variantId, 'productSku:', productSku);

  if (!variantId) {
    console.error('Could not resolve a variant id for product', productId, options);
    return;
  }

  const existingItem = items.find(item => {
    if (item.productId !== productId) return false;
    if (item.options.length !== options.length) return false;
    return item.options.every((opt, index) =>
      opt.name === options[index].name && opt.value === options[index].value
    );
  });

  const potentialTotal = totalQuantity + 1;

  if (potentialTotal > bundleLimit) {
    document.querySelectorAll('.add_to_box, .popup_addbtn').forEach(btn => btn.setAttribute('disabled', 'disabled'));
    return;
  }

  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    items.push({
      productId,
      variantId,
      quantity: 1,
      productTitle,
      productImage,
      productSku,
      options
    });
  }

  totalQuantity = items.reduce((total, item) => total + item.quantity, 0);
  renderCartItems();
  updateProgressBar();

  if (isPopup) {
    closePopup(button);
  }

  console.log("items:", items);
};


window.openProductPopup = function(button) {
  const wrapper = button.closest('.bundle_product');
  if (!wrapper) return;

  const hasPopup = wrapper.querySelector('.bundle_product_popup_main');
  if (!hasPopup) return;

  hasPopup.classList.add('open');

  const slickTarget = hasPopup.querySelector('.popup_images');
  if (!slickTarget) return;

  if ($(slickTarget).hasClass('slick-initialized')) {
    $(slickTarget).slick('unslick');
  }

  $(slickTarget).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    infinite: true
  });
};

window.closePopup = function(button) {
  const popup = button.closest('.bundle_product_popup_main');
  if (popup) {
    popup.classList.remove('open');
  }
};

function renderCartItems() {
  cartItemsContainer.innerHTML = '';

  items.forEach(item => {
    const itemWrapper = document.createElement('div');
    itemWrapper.classList.add('bundle_cart_drawer_item');
    itemWrapper.innerHTML = `
      <div class="bundle_cart_drawer_item_content">
        <img src="${item.productImage}" alt="${item.productTitle}">
        <p>${item.productTitle}</p>
      </div>
      <div class="bundle_cart_drawer_item_actions">
        <span>x${item.quantity}</span>
        <button class="remove_btn" data-product-id="${item.productId}">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
          </svg>
        </button>
      </div>
    `;

    const removeBtn = itemWrapper.querySelector('.remove_btn');
    removeBtn.addEventListener('click', () => {
      removeItem(item.productId);
    });

    cartItemsContainer.appendChild(itemWrapper);
  });
}

function removeItem(productId) {
  const itemIndex = items.findIndex(item => item.productId === productId);

  if (itemIndex !== -1) {
    if (items[itemIndex].quantity > 1) {
      items[itemIndex].quantity -= 1;
    } else {
      items.splice(itemIndex, 1);
    }
  }

  totalQuantity = items.reduce((total, item) => total + item.quantity, 0);
  // Re-enable EVERY add button (including infinite-scroll-appended ones), not just
  // the ones cached at load — a fresh query avoids leaving later products disabled.
  document.querySelectorAll('.add_to_box, .popup_addbtn').forEach(btn => btn.removeAttribute('disabled'));
  renderCartItems();
  updateProgressBar();
}


function updateProgressBar() {
  if (totalQuantity > 0) {
    bundle_progess_bar.style.display = 'flex';
    progressCount.textContent = totalQuantity;
    addToCartBtn.style.display = 'flex';

    if (totalQuantity === bundleLimit) {
      bundle_progess_bar.classList.add('qualified');
      cart.classList.add('active');
      cartOverlay.classList.add('active');
    } else {
      bundle_progess_bar.classList.remove('qualified');
      addToCartBtn.style.display = 'none';
    }
    
  } else {
    bundle_progess_bar.style.display = 'none';
  }
  drawerInfo.innerHTML = `(${totalQuantity}/${bundleLimit})`;
}

cartOverlay.addEventListener('click', hideCart);
closeDrawer.addEventListener('click', hideCart);
viewbox.addEventListener('click', openCart);

function hideCart() {
  cart.classList.remove('active');
  cartOverlay.classList.remove('active');
}

function openCart() {
  cart.classList.add('active');
  cartOverlay.classList.add('active');
}

addToCartBtn.addEventListener('click', createBundle);

// A short random token shared across all lines of one bundle "order", so that if a
// customer adds two boxes in separate sessions you can still tell which 5 chosen
// items belong together by reading the _BundleId property on each line.
function generateBundleId() {
  return 'bx_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
}

// SKU -> hidden $0 "Bundle Item" variant ID, read once from the JSON block
// rendered by the section. Keys are real product SKUs (e.g. "Sep25-04-CA-WP-RNG-GLD-5-7"),
// values are the corresponding hidden variant's numeric ID.
function getBundleItemSkuMap() {
  const el = document.querySelector('#bundle_item_sku_map');
  if (!el) return {};
  try {
    return JSON.parse(el.textContent);
  } catch (err) {
    console.error('Could not parse bundle_item_sku_map JSON:', err);
    return {};
  }
}

// Blocks re-entry: the footer button only gets a loading class, never a real
// disabled state, so a fast double-tap can fire createBundle twice and stack a
// second set of bundle items (the duplicated "Your Pick" lines seen in orders).
let bundleSubmitting = false;

// Remove any bundle already in the cart (paid main line + its hidden $0 lines)
// before adding a fresh one, so the cart can never hold two sets at once.
async function clearExistingBundle() {
  const mainVariantId = parseInt(document.querySelector('.bundle_main').getAttribute('data-product-variant-id'), 10);
  const res = await fetch(window.Shopify.routes.root + 'cart.js');
  const cart = await res.json();
  if (!cart.items || !cart.items.length) return;

  const updates = {};
  cart.items.forEach(item => {
    const handle = item.handle || '';
    const isHidden = handle === 'bundle-item' || handle === 'bundle-item-2';
    const isMain = item.variant_id === mainVariantId;
    const hasBundleId = item.properties && item.properties._BundleId;
    if (isHidden || isMain || hasBundleId) updates[item.key] = 0;
  });

  if (Object.keys(updates).length) {
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }
}

async function createBundle() {
  if (bundleSubmitting) return;               // block concurrent / double submit
  bundleSubmitting = true;
  addToCartBtn.classList.add('loading_state');

  // Clear any previous bundle first so we never stack two sets of items.
  try {
    await clearExistingBundle();
  } catch (e) {
    console.warn('clearExistingBundle failed, continuing (cleanup will catch strays):', e);
  }

  const mainProductVariantId = document.querySelector('.bundle_main').getAttribute('data-product-variant-id');
  const bundleId = generateBundleId();
  const skuMap = getBundleItemSkuMap();

  // Main bundle line carries the $60 charge and a light summary in properties,
  // useful for display in cart/checkout even though fulfillment will read the
  // separate hidden-product lines below instead of these properties.
const summaryProperties = { 'Product': 'Bundle', '_BundleId': bundleId };
items.forEach((item, index) => {
  const optionText = item.options
    .map(opt => `${opt.name}: ${opt.value}`)
    .join(", ");
  summaryProperties[`Title-${index + 1}`] = `${item.productTitle}${optionText ? ' (' + optionText + ')' : ''} x ${item.quantity}`;
  summaryProperties[`_Image-${index + 1}`] = item.productImage;   // ← add this line
});

  const lineItems = [
    {
      id: mainProductVariantId,
      quantity: 1,
      properties: summaryProperties
    }
  ];

  // Resolve each chosen item's real SKU to its hidden $0 "Bundle Item" variant.
  // This is the variant that actually goes into the cart as a separate line,
  // so it never touches the real product's price (which stays full price
  // everywhere else on the store). If a SKU has no hidden-variant counterpart
  // yet (not migrated/tested), we stop and tell the merchant which SKU is
  // missing rather than silently dropping it or charging full price.
  const missingSkus = [];
  const hiddenLineItems = [];

  items.forEach(item => {
    const hiddenVariantId = skuMap[item.productSku];

    if (!hiddenVariantId) {
      missingSkus.push(item.productSku || `(no SKU: ${item.productTitle})`);
      return;
    }

    for (let i = 0; i < item.quantity; i++) {
      hiddenLineItems.push({
        id: hiddenVariantId,
        quantity: 1,
        properties: {
          '_BundleId': bundleId,
          '_BundleRealSku': item.productSku || '',
          '_BundleRealTitle': item.productTitle
        }
      });
    }
  });

  if (missingSkus.length) {
    addToCartBtn.classList.remove('loading_state');
    bundleSubmitting = false;                 // reset on early exit
    alert(
      'Some selected items are not yet set up for checkout: ' +
      missingSkus.join(', ') +
      '. Please choose different items or contact support.'
    );
    return;
  }

  const formData = { items: [...lineItems, ...hiddenLineItems] };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) return response.json().then(err => { throw err; });
    return response.json();
  })
  .then(data => {
    addToCartBtn.classList.remove('loading_state');
    bundleSubmitting = false;                 // reset on success
    console.log("Added to cart:", data);

    // Save bundle variant ID so cleanup works on any page (cart, checkout return, etc.).
    // Best-effort only — storage may be blocked (Safari Private / in-app browsers).
    // This must NEVER stop the cart drawer from opening below, or the customer
    // is left with items silently added and no way to check out.
    const bundleEl = document.querySelector('.bundle_main');
    if (bundleEl) {
      try {
        localStorage.setItem('bundleVariantId', bundleEl.getAttribute('data-product-variant-id'));
      } catch (e) {
        console.warn('Could not persist bundleVariantId (storage blocked):', e);
      }
    }

    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    hideCart();
    document.dispatchEvent(new CustomEvent('theme:cart:toggle'));
  })
  .catch(error => {
    addToCartBtn.classList.remove('loading_state');
    bundleSubmitting = false;                 // reset on failure
    console.error('Error:', error);
    alert((error && error.description) || 'Error adding bundle to cart. Please try again.');
  });
}

})